"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTokenObtainPairRequest = instanceOfTokenObtainPairRequest;
exports.TokenObtainPairRequestFromJSON = TokenObtainPairRequestFromJSON;
exports.TokenObtainPairRequestFromJSONTyped = TokenObtainPairRequestFromJSONTyped;
exports.TokenObtainPairRequestToJSON = TokenObtainPairRequestToJSON;
exports.TokenObtainPairRequestToJSONTyped = TokenObtainPairRequestToJSONTyped;
/**
 * Check if a given object implements the TokenObtainPairRequest interface.
 */
function instanceOfTokenObtainPairRequest(value) {
    return true;
}
function TokenObtainPairRequestFromJSON(json) {
    return TokenObtainPairRequestFromJSONTyped(json, false);
}
function TokenObtainPairRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'] == null ? undefined : json['username'],
        'password': json['password'] == null ? undefined : json['password'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}
function TokenObtainPairRequestToJSON(json) {
    return TokenObtainPairRequestToJSONTyped(json, false);
}
function TokenObtainPairRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'password': value['password'],
        'code': value['code'],
    };
}
//# sourceMappingURL=tokenObtainPairRequest.js.map